import { useState } from "react";
import Converter from "../../../../functions/Converter";


export default function ContactMain ({data, name, price, dataHover, flight_or_car}) {
    const [hover, setHover] = useState(false);

    return (<>
        {
            data && 
            <div className="aufa-main-contact-data" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
                <p> {name} </p>

                {
                    (typeof data === 'object') ? 
                    <>
                        <div>
                            {
                                data.slice(1, data.length - (flight_or_car ? 1 : 3)).map((value, key) => (
                                    <p key={key}> {value} </p> 
                                ))
                            }
                        </div> 
                        {
                            dataHover && hover &&
                            <div className={"aufa-main-contact-data-hover"}>
                            {
                                dataHover.map((value, key) => {
                                    if (value && data[key + 1]) {
                                        return <p key={key}> {value}: <span> {data[key + 1]} </span> </p>
                                    }
                                })
                            }
                        </div>
                        }
                    </>
                    : 
                    <>
                        <p> {data} </p>
                        {
                            dataHover && hover &&
                            <div className={"aufa-main-contact-data-hover"}>
                                <p style={{'width': '100%'}}> {dataHover} </p>
                            </div>
                        }
                    </>
                }

                <p> <Converter num={price} /> </p>
            </div> 
        }
    </>)
}